import auth from '../../api/auth'
import session from '../../api/session'
import router from '../../router'

import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
  SET_USER
} from './types';

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY';

const state = {
  authenticating: false,
  error: false,
  token: null,
  user: null,
  errors: {}
};

const getters = {
  isAuthenticated: state => !!state.token,
  getUser: state => state.user,
  getUserId: state => state.user ? state.user._id : 0
};

const actions = {
  login(context, { username, password }) {
    context.commit(LOGIN_BEGIN);
    return auth.login(username, password)
      .then(({ data }) => {
        context.commit(SET_TOKEN, data.auth_token)
        context.dispatch('get_user', context)

        router.push('/')

      })
      .then(() => context.commit(LOGIN_SUCCESS))
      .catch((data) => context.commit(LOGIN_FAILURE, data.response.data));
  },
  logout(context) {
    return auth.logout()
      .then(() => context.commit(LOGOUT))
      .then(() => context.commit(REMOVE_TOKEN))
        .then(() => router.push('/login'))
  },
  initialize(context) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (token) {
      context.commit(SET_TOKEN, token);
      context.dispatch('get_user', context);
    } else {
      context.commit(REMOVE_TOKEN);
    }
  },
  get_user(context) {
    // console.log('get_user')
    return auth.getCurrentUser()
      .then(({ data }) => {
        // console.log('login')
        context.commit(SET_USER, data)
      })
      .catch((data) => {
        // console.log('login error', data)
        context.commit(LOGIN_FAILURE, data.response.data)
        context.commit(REMOVE_TOKEN)
      });
  }
};

const mutations = {
  [LOGIN_BEGIN](state) {
    state.authenticating = true;
    state.error = false;
  },
  [LOGIN_FAILURE](state, data) {
    state.user = null
    state.authenticating = false;
    state.error = true;
    state.errors = data
  },
  [LOGIN_SUCCESS](state) {
    state.authenticating = false;
    state.error = false;
  },
  [LOGOUT](state) {
    state.authenticating = false;
    state.user = null;
    state.error = false;
  },
  [SET_TOKEN](state, token) {
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
    session.defaults.headers.Authorization = `Token ${token}`;
    state.token = token;
  },
  [REMOVE_TOKEN](state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    delete session.defaults.headers.Authorization;
    state.token = null;
  },
  [SET_USER](state, user) {
    state.user = user
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
